import styled, { css } from 'styled-components'

import type { ToggleProps } from './ToggleDecoupled'

type ToggleStateProps = {
  isChecked: boolean
  isDisabled?: boolean
}

const disabledToggle = css`
  opacity: 0.5;
  pointer-events: none;
`

export const StyledToggle = styled.div<ToggleProps>`
  display: flex;
  align-items: center;
  cursor: pointer;
  outline: none;

  p {
    padding-left: 24px;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.altovita};
    outline-offset: 2px;
    border-radius: 4px;
  }

  ${({ isDisabled }) => isDisabled && disabledToggle}
`

export const ToggleTrack = styled.div<ToggleStateProps>`
  width: 40px;
  height: 22px;
  background-color: ${({ isChecked, theme }) =>
    isChecked ? theme.colors.sapphireDark : '#C4CDD6'};
  border-radius: 11px;
  position: relative;
`

export const ToggleThumb = styled.div<ToggleStateProps>`
  width: 18px;
  height: 18px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transform: translateX(${({ isChecked }) => (isChecked ? '18px' : '0px')});
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`
